var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.user && _vm.user.profile == 1)?_c('creditor-objection-edit-component'):(_vm.user && _vm.user.profile == 4)?_c('lawyer-objection-edit-component'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }